import chainer from './customTypeChainer';

function stringContainingInteger(props, propName, componentName) {
    const stringToTest = props[propName];
    if (!stringToTest) return;
    if (typeof stringToTest !== 'string' || typeof stringToTest === 'object') {
        return new Error(
            `Invalid prop ${propName} supplied to ${componentName}.
            Validation failed. Expected ${propName} to be a string that contains an integer,
            but ${propName} is typeof ${typeof stringToTest}.`
        );
    }
    if (stringToTest === 'new') return null;
    if (!isStringValueNumber(stringToTest)) {
        return new Error(
            `Invalid prop ${propName} supplied to ${componentName}.
            Validation failed. Expected ${propName} to be
            a string that contains an integer.`
        );
    }
    return null;
}

function isStringValueNumber(string) {
    return /^[0-9]*$/.test(string);
}

export default chainer(stringContainingInteger);
